<template>
  <div class="task-management">
    <!-- 顶部tab+按钮栏 -->
     <div style="padding: 20px; background: #fff; border-radius: 16px;">
    <div class="tasks-header-bar">
      <div class="tasks-tabs">
        <button
          :class="['tasks-tab', activeMenu === 'drawing-list' ? 'active' : '']"
          @click="handleMenuSelect('drawing-list')"
        >制图列表</button>
        <button
          :class="['tasks-tab', activeMenu === 'review-list' ? 'active' : '']"
          @click="handleMenuSelect('review-list')"
        >审核列表</button>
      </div>
      <el-button type="primary" class="upload-button" @click="openUploadImageDialog">
        <i class="el-icon-upload2"></i> 上传制图
      </el-button>
    </div>
    <el-container>
      <!-- 取消原侧边栏 -->
      <!-- 右侧内容区域 -->
      <el-main class="main-content">
        <!-- 制图列表（卡片宫格版） -->
        <div v-if="activeMenu === 'drawing-list'" class="card-list-container">
         
          <div class="card-grid">
            <div v-for="item in pagedDrawingList" :key="item.id" class="drawing-card">
              <div class="card-img-wrap">
                <img :src="item.preview" alt="预览图" class="card-img" />
              </div>
              <div class="card-info">
                <!-- <div class="card-title">作品名称：{{ item.name }}</div> -->
                <div class="card-meta">创建时间：{{ item.createTime }}</div>
                <div class="card-actions">
                  <template v-if="item.submitted">
                    <el-tag type="success" effect="plain">已提交老师</el-tag>
                  </template>
                  <template v-else>
                    <div class="card-action-left">
                      <el-button type="primary"
                                 size="mini"
                                 @click="openUploadDialog(item)">
                        提交老师
                      </el-button>
                    </div>
                    <div class="card-action-right">
                      <el-button type="danger"
                                 size="mini"
                                 @click="handleDelete(item)">
                        删除
                      </el-button>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div v-if="drawingList.length === 0" class="empty-tip">暂无作品</div>
          </div>
          <el-pagination
            v-if="drawingList.length > pageSize"
            class="card-pagination"
            background
            layout="prev, pager, next"
            :page-size="pageSize"
            :current-page.sync="drawingPage"
            :total="drawingList.length"
            @current-change="val => drawingPage = val"
          />
        </div>

        <!-- 审核列表（卡片宫格版） -->
        <div v-else-if="activeMenu === 'review-list'" class="card-list-container">
          <div class="card-grid">
            <div v-for="item in pagedReviewList" :key="item.id || item.taskName" class="drawing-card">
              <div class="card-img-wrap">
                <img :src="item.preview" alt="预览图" class="card-img" />
              </div>
              <div class="card-info">
                <div class="review-tags">
                  <span class="review-tag" :class="'state-'+item.processState">{{ getReviewStatus(item.processState) }}</span>
                  <span class="review-tag" :class="'publish-'+item.publishStatus">{{ item.publishStatus }}</span>
                </div>
                <div class="card-title">作品名称：{{ item.taskName }}</div>
                <div class="card-meta">创建时间：{{ item.createTime }}</div>
              </div>
            </div>
            <div v-if="reviewList.length === 0" class="empty-tip">暂无审核作品</div>
          </div>
          <el-pagination
            v-if="reviewList.length > pageSize"
            class="card-pagination"
            background
            layout="prev, pager, next"
            :page-size="pageSize"
            :current-page.sync="reviewPage"
            :total="reviewList.length"
            @current-change="val => reviewPage = val"
          />
        </div>

        <!-- 上传制图弹窗等其余内容保持不变 -->
      </el-main>
    </el-container>
    <!-- 上传制图弹窗 -->
    <el-dialog
      title="上传制图"
      :visible.sync="uploadImageDialogVisible"
      width="400px"
      @close="imagePreview = ''"
    >
      <el-upload
        class="upload-demo"
        drag
        action=""
        :on-change="handleChange"
        :before-upload="beforeUpload"
        :show-file-list="false"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">拖拽文件到这里，或者 <em>点击上传</em></div>
      </el-upload>
      <div v-if="imagePreview" class="image-preview">
        <h3>上传预览:</h3>
        <img :src="imagePreview" alt="上传预览" style="width: 200px; margin-top: 10px;" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="uploadImageDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="confirmUploadimg">确认上传</el-button>
      </span>
    </el-dialog>
    <!-- 提交老师弹窗 -->
    <el-dialog
      title="提交作品给老师"
      :visible.sync="uploadDialogVisible"
      width="400px"
    >
      <el-form :model="uploadForm" label-width="80px">
        <el-form-item label="作品名称">
          <el-input v-model="uploadForm.name" />
        </el-form-item>
        <el-form-item label="预览图">
          <img :src="uploadForm.preview" alt="预览图" style="width: 180px;" />
        </el-form-item>
        <el-form-item label="创建时间">
          <el-input v-model="uploadForm.createTime" disabled />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="uploadDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmUpload">确认提交</el-button>
      </span>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      activeMenu: 'drawing-list',
      uploadImageDialogVisible: false, // 新的模态框的可见性
      uploadDialogVisible: false,
      imagePreview: '', // 新增属性用于存储上传图片的预览链接
      selectedFile: '',
      uploadForm: {
        taskName: '',
        preview: '',
        createTime: '',
        id: null, // 增加ID用于唯一标识
      },
      drawingList: [],
      reviewList: [],
      hasData: false,
      drawingPage: 1,
      reviewPage: 1,
      pageSize: 8,
    };
  },
  computed: {
    pagedDrawingList() {
      const start = (this.drawingPage - 1) * this.pageSize;
      return this.drawingList.slice(start, start + this.pageSize);
    },
    pagedReviewList() {
      const start = (this.reviewPage - 1) * this.pageSize;
      return this.reviewList.slice(start, start + this.pageSize);
    }
  },
  mounted() {
    this.fetchDrawingList(); // 组件挂载时获取制图列表数据
    this.fetchReviewList()// 组件挂载时获取审核列表数据
  },
  methods: {
    async fetchDrawingList() {
      try {
        const accountNumber = localStorage.getItem('userInfo').replace(/^"|"$/g, '');
        const response = await axios.get(`/api/StudentTask/allAccountNumber?accountNumber=${accountNumber}`);

        if (response.data.success) {
          this.drawingList = response.data.data.map(item => ({
            id: item.id,
            preview: `/resources/studentTask/${item.taskUrl}`,
            createTime: this.formatDate(item.uploadTime),
            submitted: item.taskState, // 默认未提交
          }));
          // 按照创建时间降序排序
      this.drawingList.sort((a, b) => new Date(b.createTime) - new Date(a.createTime));
        } else {
          this.$message.error('获取制图列表失败');
        }
      } catch (error) {
        this.$message.error('网络错误，请稍后再试');
      }
    },
    getReviewStatus(processState) {
    switch (processState) {
      case 0:
        return '待审核';
      case 1:
        return '审核通过';
      case 2:
        return '审核不通过';
      default:
        return '未知状态';
    }
  },
  async fetchReviewList() {
  try {
    const accountNumber = localStorage.getItem('userInfo').replace(/^"|"$/g, '');
    console.log(`Fetching review list for account number: ${accountNumber}`);

    const response = await axios.get(`/api/StudentTask/allstate?accountNumber=${accountNumber}`);
    if (response.data.success) {
      this.reviewList = response.data.data.map(item => ({
        taskName: item.taskName, // 
        preview: `/resources/teacheTask/${item.taskUrl}`, 
        createTime: this.formatDate(item.uploadTime), 
        processState: item.processState, // 使用 taskState 作为状态字段
        publishStatus: item.publishState==0?'未发布':'已发布' ,
      }));
      // console.log('Review List:', this.reviewList); 
      // 按照创建时间降序排序
      this.reviewList.sort((a, b) => new Date(b.createTime) - new Date(a.createTime));
    } else {
      this.$message.error('获取审核列表失败');
      console.error('Error response:', response.data); // 打印错误信息
    }
  } catch (error) {
    this.$message.error('网络错误，请稍后再试');
    console.error('Fetch error:', error); // 打印错误对象
  }
}
,
    formatDate(timeArray) {
      // 将 [2024, 10, 18, 14, 27, 23] 格式化为 "2024-10-18 14:27:23"
      const [year, month, day, hour, minute, second] = timeArray;
      return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')} ${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}:${String(second).padStart(2, '0')}`;
    },
    handleChange(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.imagePreview = e.target.result;
        this.selectedFile = file.raw;
      };
      reader.readAsDataURL(file.raw);
    },
    handleMenuSelect(index) {
      this.activeMenu = index;
      // if(index=='drawing-list'){
      //   location.reload()
      // }
    },
    openUploadImageDialog() {
      this.uploadImageDialogVisible = true;
    },
    // eslint-disable-next-line no-unused-vars
    handleUploadSuccess(response) {
      this.imagePreview = response.url;
      // 处理上传成功的逻辑
      this.$message({
        message: '图片上传成功！',
        type: 'success',
      });
      this.uploadImageDialogVisible = false; // 关闭模态框
    },
    beforeUpload(file) {
      this.selectedFile = file.raw; // 保存选择的文件
      return true; // 允许上传
    },
    openUploadDialog(row) {
      this.uploadForm = { ...row };
      this.uploadDialogVisible = true;
      console.log(this.uploadForm.id);

    },
    confirmUpload() {
      this.$confirm('确认要上传该任务吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        try {
          // 创建 FormData 对象
          const formData = new FormData();
          const accountNumber = localStorage.getItem('userInfo').replace(/^"|"$/g, '');
      
          // 将数据添加到 FormData
          formData.append('taskName', this.uploadForm.taskName);
          formData.append('accountNumber', accountNumber);
          formData.append('id', this.uploadForm.id);

          // 发送上传请求
          const response = await axios.post('/api/StudentTask/addTeachTask', formData, {
            headers: {
              'Content-Type': 'multipart/form-data', // 设置请求头
            },
          });

          if (response.data.success) {
            this.uploadDialogVisible = false;
            this.fetchDrawingList();
            this.fetchReviewList()
            this.$message({
              message: '任务上传成功',
              type: 'success',
            });
          } else {
            this.$message.error(response.data.msg);
          }
        } catch (error) {
          this.$message.error('网络错误，请稍后再试');
        }
      });
    }
    ,
    async handleDelete(row) {
      this.$confirm('确认要删除该任务吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const accountNumber = localStorage.getItem('userInfo').replace(/^"|"$/g, '');
        try {
          // 发送删除请求
          const response = await axios.delete('/api/StudentTask/deleteStudentTask', {
            params: {
              id: row.id,
              accountNumber,
            }
          });

          // 检查删除是否成功
          if (response.data.success) {
            this.drawingList = this.drawingList.filter(item => item.id !== row.id);
            this.$message.success('任务删除成功');
          } else {
            this.$message.error('删除失败，请稍后再试');
          }
        } catch (error) {
          this.$message.error('删除失败，请稍后再试');
        }
      });
    },
    downloadParams() {
      this.$confirm('确认要下载参数吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info',
      }).then(() => {
        // 下载逻辑
      });
    },
    async confirmUploadimg() {
  if (this.selectedFile) {
    try {
      const accountNumber = localStorage.getItem('userInfo').replace(/^"|"$/g, '');
      // 使用 await 获取用户信息
      const response = await axios.get(`/api/auth/selectByAccountNumber?accountNumber=${accountNumber}`);

      // 确保返回的数据存在
      if (response.data.success) {
        const userName = response.data.data.userName; // 获取用户名
        const formData = new FormData();
        formData.append('userName', userName); // 将用户名添加到 formData
        formData.append('file', this.selectedFile);
        formData.append('accountNumber', accountNumber);

        await axios.post('/api/StudentTask/upload', formData);
        
        this.$message.success('上传成功');
        this.uploadImageDialogVisible = false;
        this.imagePreview = '';
        this.selectedFile = null;
        this.fetchDrawingList();
      } else {
        this.$message.error('获取用户名失败');
      }
    } catch (error) {
      this.$message.error('上传失败: ' + error.message);
    }
  } else {
    this.$message.warning('请先选择文件');
  }
},

  },
};
</script>

<style scoped>
.task-management {
  background: #EBF6FE;
  min-height: 100vh;
  padding: 32px;
}
.tasks-header-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 18px 0 30px 0;
  padding: 0 10px;
}
.tasks-tabs {
  display: flex;
  gap: 18px;
  padding:20px;
}
.tasks-tab {
  background: #fff;
  border: 1.5px solid #2EA2FA;
  color: #2EA2FA;
  font-size: 18px;
  border-radius: 8px;
  padding: 15px 30px;
  font-weight: 500;
  cursor: pointer;
  outline: none;
  transition: all .18s;
  
}
.tasks-tab.active {
  background: #2EA2FA;
  color: #fff;
  border: 1.5px solid #2EA2FA;
  box-shadow: 2px 2px 10px  rgba(46, 162, 250, 1);
}
.upload-button {
  font-size: 15px;
  border-radius: 10px;
  padding: 20px 26px;
  background: #2EA2FA;
  color: #fff;
  border: none;
}
.el-container {
  min-height: 100vh;
}
.main-content {
  padding: 5px 24px 0 24px;
  background: transparent;
}
.card-list-container {
  width: 100%;
}
.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 32px 24px;
  padding: 0 10px;
}
.drawing-card {
  background: #fff;
  border-radius: 18px;
  box-shadow: 0px 0px 10.84px  rgba(0, 0, 0, 0.25);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.18s, transform 0.18s;
  position: relative;
}
.drawing-card:hover {
  box-shadow: 0 6px 24px 0 rgba(46,162,250,0.16);
  transform: translateY(-4px) scale(1.015);
}
.card-img-wrap {
  width: 100%;
  background: #f6fafd;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 160px;
  border-bottom: 1px solid #f0f2f7;
  padding-bottom: 8px; /* 给图片和信息区留空间 */
}
.card-img {
  max-width: 90%;
  max-height: 130px; /* 保证图片不会超出wrap */
  object-fit: contain;
  border-radius: 10px;
  margin-bottom: 0;
}
.card-info {
  padding: 18px 18px 16px 18px;
  display: flex;
  flex-direction: column;
  flex: 1;
  text-align: justify;
  margin-top: 0;
  padding-top: 6px; /* 信息区顶部留空间，避免紧贴图片 */
}
.card-title {
  font-size: 17px;
  font-weight: 500;
  color: #222;
  margin-bottom: 6px;
  text-align: justify;
  margin-top: 0;
}
.card-meta {
  font-size: 16px;
  color: #333;
  margin-bottom: 12px;
}
.card-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0;
}
.card-action-left,
.card-action-right {
  flex: 1;
  display: flex;
}
.card-action-left {
  justify-content: flex-start;
}
.card-action-right {
  justify-content: flex-end;
}
.empty-tip {
  color: #aaa;
  text-align: center;
  margin: 60px 0;
  font-size: 16px;
  grid-column: 1/-1;
}
.review-tags {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}
.review-tag {
  display: inline-block;
  padding: 2px 14px;
  font-size: 13px;
  border-radius: 16px;
  background: #e7eaf0;
  color: #888;
  font-weight: 500;
  line-height: 20px;
}
.state-0 { background: #e7eaf0; color: #888; } /* 待审核 */
.state-1 { background: #e2f6e9; color: #1bbf6a; } /* 审核通过 */
.state-2 { background: #ffeaea; color: #E25E5E; } /* 审核不通过 */
.publish-未发布 { background: #e7eaf0; color: #888; }
.publish-已发布 { background: #e2f6e9; color: #1bbf6a; }
.card-pagination {
  margin: 24px 0 0 0;
  display: flex;
  justify-content: center;
}
@media (max-width: 1280px) {
  .card-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
}
@media (max-width: 1024px) {
  .card-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .main-content {
    padding: 5px 2vw 0 2vw;
  }
  .tasks-header-bar {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }
  .card-pagination {
    margin: 18px 0 0 0;
  }
}
</style>
